export const initialVariables = {
  fileName: '',
  deliverableTitle: '',
  release: null,
  deliverableState: '',
  storageClass: ''
};

export const initialOrderBy = 'fileName';
